import React, { useState } from "react";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function login() {
    const res = await axios.post("https://api.gutgeht.de/api/login", {
      email,
      password,
    });

    localStorage.setItem("token", res.data.token);
    window.location.href = "/users";
  }

  return (
    <div style={{ padding: 40 }}>
      <h2>DropXL Admin Login</h2>
      <input placeholder="Email" onChange={e => setEmail(e.target.value)} />
      <br />
      <input placeholder="Password" type="password" onChange={e => setPassword(e.target.value)} />
      <br />
      <button onClick={login}>Login</button>
    </div>
  );
}
